import axios from 'axios';
import Parser from 'html-react-parser';
import React, { useContext, useState } from 'react';
import AppContext from '../../context/app/appContext';

const Asset = ({ post }) => {
  const appContext = useContext(AppContext);

  const {api, postType, baseUrl, params, translations, getFiltredPosts} = appContext;
  let [ downloadFile, setDownloadFile ] = useState('');
  let [ selected, setSelected ] = useState();
  let postTerms = [];

  const {
    link,
    title,
    mediaType,
    excerpt,
    modifiedDate,
    featureImage,
    featureFile,
    featureFileFormat,
    fallbackIconClass,
    taxonomies,
    readMoreText,
    externalLink,
    tagActivated,
    tagActivatedText,
    showLinkToMoreInfo
  } = post;

  const intersperse = (arr, sep) => {
    if (arr.length === 0) {
        return [];
    }

    return arr.slice(1).reduce(function(xs, x, i) {
        return xs.concat([sep, x]);
    }, [arr[0]]);
  }

  const onTermClick = (term) => {
    const label = term.name;
    const name = term.taxonomy;
    const value = term.slug;

    setSelected(label);
    getFiltredPosts(name, value);

    handelPushState();
  };

  if(taxonomies) {
    postTerms = taxonomies.map((term, i) => {
      return(
        <span key={i} className="d-inline" onClick={() => onTermClick(term)}>{`#${term.name}`}</span>
      )
    });
    postTerms = intersperse(postTerms, " ");
  }

  const bytesToSize = (bytes) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
  }

  const getDownloadFile = (url, filename, title) => {
    /* Track event to GTM */
    if (window.dataLayer) {
      if (!title) {
        title = '[no title]';
      }

      window.dataLayer.push({
        'event':'download',
        'filename': String(filename),
        'title': String(title)
      });
    }

    axios.get(`${api}/download/?url=${url}`)
      .then(res => {
        setDownloadFile(res.data);
        downloadFile = res.data;

        setTimeout(() => {
          window.open(res.data);
        }, 100);
      });
  };

  const handelPushState = () => {
    const formData = params || {};
    let formDataForUrl = {};
    let url = '';

    for (const key in formData) {
      const value = formData[key];
      const taxKey = key.replace('-', '_');
      formDataForUrl[taxKey] = value;
    }

    if (formDataForUrl.length !== 0) {
      const data = new URLSearchParams(Object.entries(formDataForUrl));
      url = `?${decodeURIComponent(data.toString())}`;
    }else {
      url = '';
    }
    window.history.pushState(params, document.title, `${baseUrl}${url}`);
  }

  return (
    <div className={`col-sm-6 col-md-4 col-lg-3 card ${postType}`}>
        <div className="card-inner d-flex flex-column h-100 position-relative">

          {tagActivated &&
          <figure className="d-inline-block card-tag text-uppercase p-2">{Parser(tagActivatedText)}</figure>
          }

          {(() => {
          if(mediaType === 'external_link' && externalLink) {
            return(
              <a
                href={externalLink.url}
                title={externalLink.title}
                target={externalLink.target}
                rel={`${externalLink.target === '_blank' ? 'noopener noreferrer' : ''}`}
                className="d-block"
              >
                <figure className={`d-flex align-items-center justify-content-center mx-auto card-media-container text-center ${`media-type-${mediaType}`}`}>
                    <i className={fallbackIconClass}></i>
                </figure>
              </a>
            )
          } else {
            return(
              <a
                href={link}
                title={readMoreText}
                className="d-block"
              >
                {featureImage ? (
                  <figure className={`special d-flex align-items-center justify-content-center mx-auto card-media-container text-center ${`media-type-${mediaType}`}`} dangerouslySetInnerHTML={{ __html: featureImage }}/>
                ) : (
                  <figure className={`special d-flex align-items-center justify-content-center mx-auto card-media-container text-center ${`media-type-${mediaType}`}`}>
                    <i className={fallbackIconClass}></i>
                  </figure>
                )}

              </a>
            )
          }
          })()}

          <div className="card-content">
            <h4 className="card-title">
              <a href={link} title={Parser(title)} className="d-block">
                {Parser(title)}
              </a>
            </h4>

            {excerpt &&
            <div className="card-text detail-texts">
              {Parser(excerpt)}
            </div>
            }
          </div>

          <div className="card-actions d-flex align-items-center">

            {(() => {
              if(mediaType === 'external_link' && externalLink) {
                return(
                  <a
                    href={externalLink.url}
                    title={externalLink.title}
                    target={externalLink.target}
                    rel={`${externalLink.target === '_blank' ? 'noopener noreferrer' : ''}`}
                    className="btn btn-primary btn-small btn-download text-uppercase no-underline color-white card-action-download"
                  >
                    <div className="d-flex align-items-center">
                      <i className="icon-external-link"></i>
                      {externalLink.title}
                    </div>
                  </a>
                )
              } else if(featureFile.url) {
                return(
                  <button
                    type="button"
                    className="btn btn-primary btn-small btn-download text-uppercase no-underline color-white card-action-download"
                    onClick={() => getDownloadFile(featureFile.url, escape(featureFile.filename), Parser(title))}
                  >
                    <i className="icon-download"></i>
                    <div className="d-inline file-format ml-1">
                      {featureFileFormat && featureFileFormat}
                    </div>
                    <div className="d-inline file-size ml-1">
                      {featureFile && bytesToSize(featureFile.filesize)}
                    </div>
                  </button>
                )
              }
            })()}

            {(() => {
              if(showLinkToMoreInfo && mediaType !== 'external_link') {
                return(
                  <a href={link} title={readMoreText} className="card-action-download ml-3 link-label">
                    {readMoreText}
                  </a>
                )
              }
            })()}

          </div>

          {postTerms &&
          <div className="card-hashes d-flex flex-grow-1 text-uppercase mt-2 mt-md-3">
            <div className="d-block">
              {postTerms}
            </div>
          </div>
          }

          <div className="card-footer mt-2 mt-md-3">
            <div className="card-modified-date">
              {`${translations.modifiedDate} ${modifiedDate}`}
            </div>
          </div>

        </div>
    </div>
  );
};

export default Asset;



// WEBPACK FOOTER //
// ./src/components/Posts/Asset.js